module.exports = __webpack_public_path__ + "img/einvoice-download-white.63d35949.svg";